import { ChainSelectorInput } from "./ChainSelectorInput";

interface UnitSelectProps {
	readonly value: string;
	readonly onChange: Setter<string>;
	readonly errors?: string[];
	readonly label?: string;
	readonly placeholder: string;
}
export function UnitSelect(props: UnitSelectProps) {
	/**
	 * Unidades que se pueden usar para medir algo "fisico"
	 */
	const unidadesFisicas = [
		{
			id: "masa", label: "Peso", children: [
				{
					id: "masa_metrico", label: "Metrico", children: [
						{ id: "gram", label: "Gramo" },
						{ id: "kilogram", label: "Kilogramo" },
						{ id: "ton", label: "Tonelada" },
					],
				},
				{
					id: "masa_imperial", label: "Imperial", children: [
						{ id: "ounce", label: "Onza" },
						{ id: "pound", label: "Libra" },
						{ id: "stone", label: "Stone" },
					],
				},

			],
		},
		{ id: "_u", label: "Unidad" },
		// {
		// 	id: "cantidad", label: "Cantidad", children: [
		// 		{ id: "_u", label: "Unidad" },
		// 		{ id: "_cientos", label: "Cientos" },
		// 		{ id: "_miles", label: "Miles" },
		// 	],
		// },
		{
			id: "energia", label: "Energía", children: [
				{ id: "Wh", label: "Vatio-hora" },
				{ id: "kWh", label: "Kilovatio-hora" },
				{ id: "J", label: "Julio" },
				{ id: "kJ", label: "Kilojulio" },
			],
		},
		{
			id: "area", label: "Área", children: [
				{ id: "cm2", label: "Centímetro cuadrado" },
				{ id: "m2", label: "Metro cuadrado" },
			],
		},
		{
			id: "volumen", label: "Volumen", children: [
				{ id: "ml", label: "Mililitro" },
				{ id: "l", label: "Litro" },
				{ id: "m3", label: "Metro cúbico" },
			],
		},
	];


	return (
		<ChainSelectorInput
			value={props.value}
			onChange={props.onChange}
			label={props.label}
			placeholder={props.placeholder}
			values={unidadesFisicas}
			errors={props.errors}
		/>
	);
}
/*
				{ id: "MASA", label: "Masa" },
				{ id: "TIEMPO", label: "Tiempo" },
				{ id: "CANTIDAD", label: "Cantidad" },

				{ id: "Fuerza", label: "Fuerza" },
				{ id: "Presión", label: "Presión" },

				{ id: "Trabajo", label: "Trabajo" },
				{ id: "Potencia", label: "Potencia" },

				{ id: "CORRIENTE", label: "Intensidad de corriente eléctrica" },
				{ id: "Carga eléctrica", label: "Carga" },
				{ id: "PotencialElectrico", label: "Potencial" },
				{ id: "ResistenciaElectrica", label: "Resistencia" },
				{ id: "ConductanciaElectrica", label: "Conductancia" },
				{ id: "CapacitanciaElectrica", label: "Capacitancia" },
				{ id: "IntensidadCampoEléctrico", label: "Intensidad" },
				{ id: "Inductancia", label: "Inductancia" },


				{ id: "InduccionMagnetica", label: "Inducción Magnética" },
				{ id: "FlujoMagnetico", label: "Flujo Magnético" },
				{ id: "PermeabilidadMagnética", label: "Permeabilidad" },
				{ id: "IntensidadCampoMagnético", label: "Intensidad" },


				{ id: "TEMPERATURA", label: "Temperatura" },
				{ id: "Irradiancia", label: "Irradiancia" },
				{ id: "Conductividad térmica", label: "Conductividad" },


				{ id: "LONGITUD", label: "Longitud" },
				{ id: "ÁnguloPlano", label: "Ángulo plano" },
				{ id: "ÁnguloSólido", label: "Ángulo sólido" },

				{ id: "LUMINOSA", label: "Intensidad luminosa" },
				{ id: "FlujoLuminoso", label: "Flujo luminoso" },
				{ id: "Luminosidad", label: "Luminosidad" },

				{ id: "ActividadRadiactiva", label: "Actividad Radiactiva" },
				{ id: "DosisAbsorbidaRadiacionIonizante", label: "Dosis Absorbida de Radiación Ionizante" },
				{ id: "EquivalenciaDosisRadiacionIonizante", label: "Equivalencia Dosis de Radiación Ionizante" },
				{ id: "Tasa de dosis absorbida", label: "Tasa" },
				{ id: "Exposición (rayos X y gamma)", label: "Exposición" },


				{ id: "Área", label: "Área" },
				{ id: "Volumen", label: "Volumen" },
				{ id: "Densidad", label: "Densidad" },
				{ id: "VolumenEspecífico", label: "Volumen Específico" },

				{ id: "Velocidad", label: "Velocidad" },
				{ id: "Velocidad angular", label: "Velocidad angular" },
				{ id: "Aceleración", label: "Aceleración" },
				{ id: "Momento de Fuerza", label: "Momento de Fuerza" },
				{ id: "Caudal", label: "Caudal, Flujo volumétrico" },

				{ id: "Actividad catalítica", label: "Actividad Catalítica" },

				{ id: "CANTIDADSUSTANCIA", label: "Cantidad de sustancia" },
				{ id: "Concentración", label: "Concentración" },
				{ id: "VolumenMolar", label: "Volumen molar" },
				{ id: "EnergíaMolar", label: "Energía" },
				{ id: "EnergíaEspecífica", label: "Energía Específica" },
				{ id: "DensidadEnergía", label: "Densidad de energía" },

				{ id: "Tensión superficial", label: "Tensión" },
				{ id: "ViscosidadCinemática", label: "Viscosidad" },
				{ id: "ViscosidadDinámica", label: "Viscosidad" },
*/